{
  "files.title": "Files",
  "files.task.title": "Attachments",
  "files.task.empty": "No files on this task yet.",
  "files.loadError": "We could not load the files.",
  "files.loadMore": "Show more files",
  "files.loadingMore": "Loading…",
  "files.search": "Search files",
  "files.pastedName": "Screenshot",
  "files.inComment": "Attached to a comment",
  "files.drop.title": "Drop files here, paste a screenshot, or browse",
  "files.drop.release": "Release to upload",
  "files.drop.hint": "Images, PDF, Office, text, MP4 or ZIP, up to {size} MB each",
  "files.upload.button": "Upload files",
  "files.upload.listLabel": "Uploads",
  "files.upload.waiting": "Waiting to upload…",
  "files.upload.progress": "Uploading… {percent}",
  "files.upload.progressLabel": "Upload of {name}",
  "files.upload.cancelled": "Upload cancelled.",
  "files.upload.cancel": "Cancel the upload of {name}",
  "files.upload.dismiss": "Dismiss {name}",
  "files.problem.tooLarge": "This file is too big. Files can be up to {size} MB.",
  "files.problem.notAllowed": "This type of file is not allowed. Use an image, PDF, Office file, text, MP4 or ZIP.",
  "files.problem.mismatch": "This file’s content does not match its type. Save it again in the right format and retry.",
  "files.problem.empty": "This file is empty.",
  "files.problem.network": "The connection dropped. Check your internet and try again.",
  "files.problem.forbidden": "You cannot add or change files here.",
  "files.problem.gone": "This file is no longer here.",
  "files.problem.generic": "Something went wrong. Try again.",
  "files.actions.label": "Actions for {name}",
  "files.actions.openNamed": "Open {name}",
  "files.actions.openInTab": "Open in a new tab",
  "files.actions.download": "Download",
  "files.actions.remove": "Remove",
  "files.remove.title": "Remove this file?",
  "files.remove.body": "{name} will disappear from the task and the project for everyone.",
  "files.remove.pending": "Removing…",
  "files.versions.title": "Version history",
  "files.versions.number": "v{number}",
  "files.versions.open": "{count, plural, one {# version} other {# versions}}: show the history",
  "files.versions.upload": "Upload a new version",
  "files.versions.uploaded": "{name} is now version {number}.",
  "files.versions.uploading": "New version… {percent}",
  "files.versions.loadError": "We could not load the versions.",
  "files.lightbox.position": "{position} of {total}",
  "files.lightbox.previous": "Previous image",
  "files.lightbox.next": "Next image",
  "files.groups.project": "Project files",
  "files.empty.title": "No files yet",
  "files.empty.body": "Drop files here or upload them. Files attached to tasks show up here too.",
  "files.empty.bodyReadOnly": "Files attached to the project and its tasks will show up here.",
  "files.empty.filteredTitle": "No files match",
  "files.empty.filteredBody": "Try another name or file type.",
  "files.filter.label": "File type",
  "files.filter.all": "All",
  "files.filter.image": "Images",
  "files.filter.document": "Documents",
  "files.filter.video": "Videos",
  "files.filter.archive": "Archives",
  "files.filter.clear": "Clear filters",
  "files.kind.image": "Image",
  "files.kind.vector": "Vector image (SVG)",
  "files.kind.pdf": "PDF document",
  "files.kind.document": "Word document",
  "files.kind.spreadsheet": "Excel spreadsheet",
  "files.kind.slides": "PowerPoint presentation",
  "files.kind.table": "CSV table",
  "files.kind.text": "Text file",
  "files.kind.video": "Video",
  "files.kind.archive": "ZIP archive",
  "files.kind.file": "File"
}
